import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step2 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.justification)) {
      newErrors.justification = "Justification is required";
    } else if (data.justification.length > 250) {
      newErrors.justification = "Justification must be up to 250 characters";
    }

    if (isEmpty(data.paymentTerms)) {
      newErrors.paymentTerms = "Payment Terms are required";
    } else if (data.paymentTerms.length > 250) {
      newErrors.paymentTerms = "Payment terms must be up to 250 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-advance?draftSraId=${sra.draftVendorAdvanceId}`,
        {
          justification: sra.justification,
          paymentTerms: sra.paymentTerms,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/approval/dashboard/create-vendor-advance/draft/${sra.draftVendorAdvanceId}`)
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Vendor Advance</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "40%" }}></span>
      </div>
      <div className="dashboard-container">
        <Box>
          <Typography className="form-title">Justification</Typography>
          <label htmlFor="justification">
            Justification (Why Advance Payment?) <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.justification && "input-error"}`}
            name="justification"
            id="justification"
            onChange={handleChange}
            value={sra?.justification || ""}
            rows={4}
          />
          {errors.justification && (
            <p className="error">{errors.justification}</p>
          )}
          <label htmlFor="paymentTerms">
            Payment Terms <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.paymentTerms && "input-error"}`}
            name="paymentTerms"
            id="paymentTerms"
            onChange={handleChange}
            value={sra?.paymentTerms || ""}
            rows={4}
          />
          {errors.paymentTerms && (
            <p className="error">{errors.paymentTerms}</p>
          )}
        </Box>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
